import React, { useMemo,useState,useEffect } from "react";
import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  MenuItem,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { CiSearch } from "react-icons/ci";
import { useFormik } from "formik";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import ListIcon from '@mui/icons-material/List';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from '@mui/material/Autocomplete';
import {
  ICustomer,
  IServerType,
  IDomainProviders,
  IDomains,
} from "../../../Api/Interface/api.interface";
import {
  useCreateDomainMutation,
  useGetCustomerQuery,
  useGetServerTypeQuery,
  useGetServerCompanyQuery,
  useGetDomainProviderQuery,
} from "../../../Api/attoDeskApi";
import dayjs, { Dayjs } from "dayjs";

interface IServerpopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  data?: IDomains;
}

const Servers = ({ openModel = false, handleCloseDialog, data }: IServerpopup) => {
  const classes = useStyles();
  const [open] = React.useState(openModel);
  const [newServer, { isLoading }] = useCreateDomainMutation();
  const { showErrorMessage, showMessage } = useNotifier();
    const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
        useState<string>("");
    const [currentSearchQueryServerType, setCurrentSearchQueryServerType] =
        useState<string>("");
    const [currentSearchQueryServerCompany, setCurrentSearchQueryServerCompany] =
        useState<string>("");
    const [selectedCustomer, setSelectedCustomer] = useState<ICustomer | null>(null);
    const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
    const [showDropdownCustomer, setShowDropdownCustomer] =
        useState<boolean>(false);
    const [showCustomerError, setShowCustomerError] = React.useState(false);
    const [showDropdown, setShowDropdown] = useState(true);
    const [showDropdownCompany, setShowDropdownCompany] = useState(true);
    const [showNew, setShowNew] = useState(false);
    const [showNewCompany, setShowNewCompany] = useState(false);
    const [currentSearchQueryDomainProvider, setCurrentSearchQueryDomainProvider] =
          useState<string>("");
  const handleClose = () => {
    handleCloseDialog(false);
  };

  const {
        data: customerData,
        isLoading: customerIsLoading,
        isError: cutomerError,
        refetch: cutomerRefetch,
      } = useGetCustomerQuery({
        searchText: currentSearchQueryCustomer,
        id: "",
      });
  
       const {
        data: serverTypeData,
        isLoading: serverTypeLoading,
        isError: serverTypeError,
        refetch:serverTypeRefetch,
      } = useGetServerTypeQuery({
        searchText: currentSearchQueryServerType,
      });
  
       const {
        data: serverCompanyData,
        isLoading: serverCompanyLoading,
        isError: serverCompanyError,
        refetch:serverCompanyRefetch,
      } = useGetServerCompanyQuery({
        searchText: currentSearchQueryServerCompany,
      });

      
           const {
            data: domainProviderData,
            isLoading: domainProviderLoading,
            isError: domainProviderError,
            refetch:domainProviderRefetch,
          } = useGetDomainProviderQuery({
            searchText: currentSearchQueryDomainProvider,
          });
      
  
      const customerList: ICustomer[] = Array.isArray(customerData?.data)
        ? (customerData?.data as ICustomer[])
        : [];
  
          const domainProviderList: IDomainProviders[] = Array.isArray(domainProviderData?.data)
        ? (domainProviderData?.data as IDomainProviders[])
        : [];
  
        const handleSelectCustomer = (customerId: string) => {
      const selectedCustomer = customerList.find(
        (customer) => String(customer.id) === customerId
      );
      if (selectedCustomer) {
  
        const customerFormattedAddress = customerFormatAddress(
          selectedCustomer.customerStreetNumber || "",
          selectedCustomer.customerStreetName || "",
          selectedCustomer.customerCity || "",
          selectedCustomer.customerProvince || "",
          selectedCustomer.customerPostalCode || "",
        );
  
        setSearchQueryCustomer(
          // (selectedCustomer.customerFirstName || " ") +
          //   " " +
          //   (selectedCustomer.customerLastName || " ")
          selectedCustomer.customerCompanyName
        );
  
        formik.setFieldValue(
          "customerCompanyName",
          selectedCustomer.customerCompanyName  || ""
        );
          formik.setFieldValue(
          "customerFirstName",
          selectedCustomer.customerFirstName || ""
        );
        formik.setFieldValue(
          "customerLastName",
          selectedCustomer.customerLastName || ""
        );
        formik.setFieldValue(
          "customerMobileNum",
          selectedCustomer.customerMobileNum || ""
        );
        formik.setFieldValue("customerEmail", selectedCustomer.customerEmail|| "");
        
        formik.setFieldValue("customerAddress", customerFormattedAddress|| "");
        formik.setFieldValue("quoteWorkOrderCustomerId", selectedCustomer.id);
      }
      setShowDropdownCustomer(false);
    };
  
      const customerFormatAddress = (
      streetNumber: string,
      streetName: string,
      city: string,
      province: string,
      postalCode: string,
    ) => {
      if (!streetNumber && !streetName && !city && !province && !postalCode) {
        return ""; // Return an empty string if all fields are empty
      }
  
      return `${streetNumber} ${streetName},\n${city}, ${province}, ${postalCode}`;
    };
  
  
            const filterOptions = createFilterOptions({
                matchFrom: 'any', // Match anywhere in the string
                stringify: (option: any) => {
                  if (typeof option === 'string') return option;
                  // Combine fields for searching
                  return `${option.customerFirstName} ${option.customerLastName} ${option.customerMobileNum}`;
                },
              });
  
useEffect(() => {
  if (data?.customerId && customerList.length > 0) {
    const customer = customerList.find(c => String(c.id) === String(data.customerId));
    if (customer) {
      setSelectedCustomer(customer);
      setSearchQueryCustomer(`${customer.customerFirstName} ${customer.customerLastName}`);
    }
  }
}, [data, customerList]);



 const formik = useFormik({
  initialValues: {
     id: data?.id ,
    customerId: data?.customerId || "",
    name: data?.name || "",
    domainProviderId: data?.domainProviderId || "",
    expiryDate: data?.expiryDate ? dayjs(data.expiryDate) : null,
  },
  onSubmit: async (values, { resetForm }) => {
    try {
      const temData = {
        id: values?.id,
        name: values.name,
        customerId: selectedCustomer?.id || values.customerId,
        domainProviderId:  String(values.domainProviderId),
        expiryDate: values.expiryDate,
      };
        if (!data) {
          delete values.id;
        }

        const addCompanyResponse = await newServer(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          handleClose();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
      return formik.values.domainProviderId && formik.values.domainProviderId !== "" ||
      formik.values.customerId && formik.values.customerId !== ""  ||
        formik.values.name && formik.values.name !== "" 
        ? true
        : false;
    }, [formik]);

  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          maxWidth: "1700px",
        },
      }}
    >
      <Grid className={classes.Dialog}>
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Edit Domain 
                  </Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item lg={9} md={9} sm={12} xs={12}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Domain Information
                        </Typography>
                      </Grid>
                    </Grid>

                  <Grid container spacing={3} p={"24px"}>
                 
                 <Grid item lg={7} md={7} sm={12} xs={12}>
                   <Grid container alignItems="center">
                     <Grid item xs={12}>
                       <Typography variant="subtitle1">Domain Provider<span style={{ color: "red" }}> *</span></Typography>
                     </Grid>
                 
                         <TextField
                           select
                           size="small"
                           className={classes.textField}
                           {...formik.getFieldProps("domainProviderId")}
                           defaultValue=""
                         >
                           <MenuItem value="" disabled>
                             Select an option
                           </MenuItem>
                           {domainProviderList.map((type, index) => (
                             <MenuItem key={index} value={type.id}>
                               {type.name} - - {type.company?.name} - {type.domainProviderId}
                             </MenuItem>
                           ))}
                         </TextField>
                        
                   </Grid>
                 </Grid>
                 
                                     <Grid item lg={7} md={7} sm={12} xs={12}>
                                       <Grid container alignItems="center">
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                           <Typography variant="subtitle1">Select Customer <span style={{ color: "red" }}> *</span></Typography>
                                         </Grid>
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                 <Autocomplete
                                     options={customerList}
                                    getOptionLabel={(option) => {
                                   if (typeof option === 'string') return option;
                                   const name = `${option.customerFirstName || ''} ${option.customerLastName || ''}`;
                                   const company = option.customerCompanyName ? ` (${option.customerCompanyName})` : '';
                                   return `${name}${company}`;
                                 }}
                                 
                                     filterOptions={filterOptions}
                                     value={selectedCustomer || null}
                                     onChange={(event, newValue) => {
                                       if (typeof newValue === 'object' && newValue !== null) {
                                         setSelectedCustomer(newValue);
                                         handleSelectCustomer(String(newValue.id));
                                         setSearchQueryCustomer(`${newValue.customerFirstName} ${newValue.customerLastName}`);
                                       } else if (typeof newValue === 'string') {
                                         setSearchQueryCustomer(newValue);
                                         setSelectedCustomer(null);
                                         handleSelectCustomer("");
                                       }
                                     }}
                                     onInputChange={(event, newInputValue) => {
                                       setSearchQueryCustomer(newInputValue);
                                       if (newInputValue === '') {
                                         setSelectedCustomer(null);
                                       }
                                     }}
                                     renderInput={(params) => (
                                       <TextField
                                         {...params}
                                         value={searchQueryCustomer}
                                         onChange={(e) => setSearchQueryCustomer(e.target.value)}
                                         placeholder="Search Customer"
                                         size="small"
                                     error={showCustomerError && !selectedCustomer}
                                   helperText={showCustomerError && !selectedCustomer ? "Customer selection is required" : ""}
                                         InputProps={{
                                           ...params.InputProps,
                                           startAdornment: (
                                             <InputAdornment position="start">
                                               <Box sx={{ pr: 2 }}>
                                                 <CiSearch className={classes.searchWidgetIcon} />
                                               </Box>
                                             </InputAdornment>
                                           ),
                                        
                                         }}
                                         sx={{
                                           width: "100%",
                                           border: 'none !important',
                                           color: 'theme.palette.primary.main',
                                         }}
                                       />
                                     )}
                                   />
                            
                                        </Grid>
                                        </Grid>
                                          </Grid>
                   
                 
                    
                 
                 
                 
                                  
                                     <Grid item lg={7} md={7} sm={12} xs={12}>
                                       <Grid container alignItems="center">
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                           <Typography variant="subtitle1">Domain Name<span style={{ color: "red" }}> *</span></Typography>
                                         </Grid>
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                           <TextField
                                             placeholder="Enter Name"
                                             size="small"
                                             {...formik.getFieldProps("name")}
                                             className={classes.textField}
                                             InputProps={{
                                               sx: {
                                                 fontSize: 14,
                                               },
                                             }}
                                             InputLabelProps={{
                                               sx: {
                                                 fontSize: 14,
                                               },
                                             }}
                                           />
                                         </Grid>
                                       </Grid>
                                     </Grid>
                 
                                     <Grid item lg={7} md={7} sm={12} xs={12}>
                                       <Grid container alignItems="center">
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                           <Typography variant="subtitle1">
                                             Expiry Date
                                           </Typography>
                                         </Grid>
                                         <Grid item lg={12} md={12} sm={12} xs={12}>
                                             <LocalizationProvider dateAdapter={AdapterDayjs}>
                                             <DatePicker
                                               value={formik.values.expiryDate}
                                               onChange={(date) =>
                                                 formik.setFieldValue(
                                                   "expiryDate",
                                                   date
                                                 
                                                 )
                                               }
                                               slotProps={{
                                                 textField: {
                                                   size: "small",
                                                   sx: { width: "100%" },
                                                   InputProps: {
                                                     sx: { fontSize: 14 },
                                                   },
                                                   InputLabelProps: {
                                                     sx: { fontSize: 14 },
                                                   },
                                                 },
                                               }}
                                             />
                                           </LocalizationProvider>
                                         </Grid>
                                       </Grid>
                                     </Grid>
                                   </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<SaveAltIcon />}
                          className={classes.addButton}
                          onClick={() => formik.handleSubmit()}
                          disabled={!formValid || isLoading}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default Servers;
